import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpPost, HttpResponse, Quark, Url } from 'sol-request-angular/dist/comunicacao';
import { environment } from 'src/environments/environment';
import { environmentv3 } from 'src/environments/environmentv3';


@Injectable()
export class UtilsController {

	httpOptions = {
		headers: new HttpHeaders({ 'Response-Type': 'text' })
	}

	constructor(public http: HttpClient) { }

	async status(): Promise<any> {
		return new Promise((resolve, reject) => {
			this.http.get(`${environment.protocol}://${environment.host}:${environment.port}/${environment.context}/rws/util/developer/status`, { responseType: 'text' })
				.subscribe(res => {
					resolve(res);
				}, (err) => {
					reject(err);
				});
		})
	}

	async initDDL(): Promise<string> {
        let quark = new Quark(
            new HttpPost({
                url: new Url({
                    id: 'util/ddl/init',
                    environment: environmentv3
                }),
            }),
            new HttpResponse(new Object())
        )

        return quark.call()
    }
}